import React, { Dispatch, ReactNode, SetStateAction } from "react";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, IconButton, Typography } from "@mui/material";

import styles from "./ManualSlider.module.scss";

const ManualSlider: React.FC<{
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  slides: Array<{
    id: number;
    content: ReactNode;
  }>;
}> = ({ slides, step, setStep }) => {
  const next = () => {
    if (step < slides.length - 1) setStep(step + 1);
  };

  const prev = () => {
    if (step > 0) setStep(step - 1);
  };

  return (
    <>
      <Box className={styles.wrapper}>
        <div className={styles.main}>{slides[step].content}</div>

        <Box className={styles.sidebar}>
          {slides.map((s, i) => (
            <div
              key={s.id}
              className={`${styles.slideItem} ${
                i === step ? styles.active : ""
              }`}
              onClick={() => setStep(i)}
            >
              {s.content}
            </div>
          ))}
        </Box>
      </Box>

      <Box className={styles.controls}>
        <IconButton onClick={prev} disabled={step === 0}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        <Typography>
          {step + 1} of {slides.length}
        </Typography>
        <IconButton onClick={next} disabled={step === slides.length - 1}>
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Box>
    </>
  );
};

export default ManualSlider;
